import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { useNavigate } from 'react-router-dom';
import { fetchUsers, createUser, deleteUser, updateUser } from '../../common/jsonstore';
import { User } from '../../common/model';
import { AppState } from '../../redux/store/rootReducer';
import { AppDispatch } from '../../redux/store/store';
import { isTokenExpired } from '../../services/authenticationService';
import { removeTokens, signOut } from '../../services/localStorage';
import { handleError, handleSuccess } from '../../services/messageApiService';


const initialState: User[] = [];

const UserSlice = createSlice({
  name: 'Users',
  initialState,
  reducers: {
    receiveUsers(state, action: PayloadAction<User[]>) {
      return action.payload;
    },
    receiveUser(state, action: PayloadAction<User>) {
      state.push(action.payload);
    },
    // toggleUser(state, action: PayloadAction<User>) {
    //   let User = state.find(User => User.id === action.payload.id);

    //   if (User) {
    //     User.completed = !User.completed;
    //   }
    // },
  }
});
// export const { toggleUser } = UserSlice.actions;

export const loadUsers = (): any => async (dispatch: AppDispatch) => {
  if (isTokenExpired()) {
    const Users = await fetchUsers().then((res: any) => {
      dispatch(UserSlice.actions.receiveUsers(res))
    }).catch((err: any) => {
      if (err?.response?.data?.message?.includes("access token")) {
        handleError(err.response.data.message);
        setTimeout(() => { return signOut(); }, 500);
      } else {
        let msg = (err?.response?.data?.message) ? err?.response?.data?.message : 'Something Happened';
        handleError(msg);
      }
    })
  } else {
    handleError('Token is expired');
    setTimeout(() => { return signOut(); }, 500);
  }
}

export const addUser = (newUser: User): any => async (dispatch: AppDispatch, getState: () => AppState) => {
  if (isTokenExpired()) {
    const res = await createUser(newUser).then((resp: any) => {
      dispatch(UserSlice.actions.receiveUser(resp));
      handleSuccess('User added successfully');
    }).catch((err: any) => {
      if (err?.response?.data?.message?.includes("access token")) {
        handleError(err.response.data.message);
        setTimeout(() => { return signOut(); }, 500);
      } else {
        let msg = (err?.response?.data?.msg) ? err?.response?.data?.msg : 'User not added';
        handleError(msg);
      }
    })

  } else {
    handleError('Token is expired');
    setTimeout(() => { return signOut(); }, 500);
  }
}

export const modifyUser = (newUser: User, id: number): any => async (dispatch: AppDispatch, getState: () => AppState) => {
  if (isTokenExpired()) {
    const res = await updateUser(newUser, id).then((resp: any) => {
      const updatedUsers = getState().Users.map((el: any) => (el.id === id ? resp : el))
      dispatch(UserSlice.actions.receiveUsers(updatedUsers));
      handleSuccess('User updated successfully');
    }).catch((err: any) => {
      if (err?.response?.data?.message?.includes("access token")) {
        handleError(err.response.data.message);
        setTimeout(() => { return signOut(); }, 500);
      } else {
        let msg = (err?.response?.data?.msg) ? err?.response?.data?.msg : 'User not updated';
        handleError(msg);
      }
    })
  } else {
    handleError('Token is expired');
    setTimeout(() => { return signOut(); }, 500);
  }
}

export const removeUser = (id: number): any => async (dispatch: AppDispatch, getState: () => AppState) => {
  if (isTokenExpired()) {
    deleteUser(id).then((resp: any) => {
      const updatedUsers = getState().Users.filter((item: any) => item.id !== id);
      dispatch(UserSlice.actions.receiveUsers(updatedUsers));
      handleSuccess('User Deleted Successfully');
    }).catch((err: any) => {
      if (err?.response?.data?.message?.includes("access token")) {
        handleError(err.response.data.message);
        setTimeout(() => { return signOut(); }, 500);
      } else {
        let msg = (err?.response?.data?.msg) ? err?.response?.data?.msg : 'User not deleted';
        handleError(msg);
      }
    })
  } else {
    handleError('Token is expired');
    setTimeout(() => { return signOut(); }, 500);
  }
}

export default UserSlice.reducer;
